import { ENDPOINT } from 'api/endPoints/getLogicCheckerCategoryResults';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const criticalPathTest: IHashmapItemComponentProps = {
    NoPermissionMessage,
    componentKey: 'criticalPathTest',
    title: 'Critical Path Test',
    id: 'criticalPathTest',
    globalFiltersConfig: [
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
        },
        widgetInitialSize: MEDIUM,
    },
    endpoint: ENDPOINT,
};
